import React from "react";

const ErrorFallBackCard = () => {
  return (
    <h1>Something went wrong.</h1>
    // <></>
  );
};

export default ErrorFallBackCard;
